(() => {
  let reviews;
  if (!customElements.get('al-basket-reviews')) customElements.define('al-basket-reviews', class extends HTMLElement {
    async connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      try {
        reviews ||= fetch(this.dataset.src).then(r => { if (!r.ok) throw Error('Reviews unavailable'); return r.json(); }).catch(() => []);
        this.rows = await reviews;
        if (!this.isConnected || !this.rows.length) return;
        this.hidden = false;
        this.draw();
        this.addEventListener('mouseenter', () => { this.hovered = true; }, {signal});
        this.addEventListener('mouseleave', () => { this.hovered = false; }, {signal});
        this.addEventListener('touchstart', event => { this.touchX = event.touches[0].clientX; this.touched = true; }, {signal, passive:true});
        this.addEventListener('touchend', event => {
          const distance = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(distance) > 40) this.step(distance < 0 ? 1 : -1);
          this.touched = false;
        }, {signal, passive:true});
        this.addEventListener('touchcancel', () => { this.touched = false; }, {signal, passive:true});
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); }
        }, {signal});
        this.timer = setInterval(() => {
          const visible = this.getBoundingClientRect();
          if (!document.hidden && !this.motion.matches && !this.hovered && !this.touched && !this.contains(document.activeElement) && visible.bottom > 0 && visible.top < innerHeight && this.closest('cart-drawer')?.classList.contains('active')) this.step(1);
        }, 8000);
      } catch (_) { this.hidden = true; }
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); }
    step(direction) { this.index = (this.index + direction + this.rows.length) % this.rows.length; this.draw(); }
    draw() {
      const row = this.rows[this.index];
      const header = document.createElement('div'); header.className = 'al-basket__review-person';
      const photo = this.getAttribute('data-portrait-' + row.p); let avatar; if (photo) { avatar = document.createElement('img'); avatar.src = photo; avatar.alt = ''; avatar.width = 44; avatar.height = 44; avatar.decoding = 'async'; } else { avatar = document.createElement('span'); avatar.className = 'al-basket__initial'; avatar.setAttribute('aria-hidden', 'true'); avatar.textContent = (row.n || '').trim().charAt(0); }
      const info = document.createElement('div');
      const author = document.createElement('cite'); author.textContent = row.n;
      const stars = document.createElement('span'); stars.className = 'al-basket__stars'; stars.textContent = '★'.repeat(row.s); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', this.dataset.ratingLabel);
      info.append(author, stars); header.append(avatar, info);
      const quote = document.createElement('blockquote'); quote.textContent = '“' + row.b + '”';
      this.querySelector('[data-review-body]').replaceChildren(header, quote);
    }
  });
})();
